import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import { CONTAINER_MAX_WIDTH } from '../Container/props/containerProps';
import Container from '../Container';

import './shortContact.scss';

const ShortContact: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="ShortContact">
      <Container maxWidth={CONTAINER_MAX_WIDTH.LG}>
        <Divider className="divider" />
        <section className="ShortContact-Section">
          <p>{t('short_contact.info')}</p>
        </section>
      </Container>
    </section>
  );
};

export default ShortContact;
